























































































































































































import moment from 'moment'
import { Component, Prop } from 'vue-property-decorator'

import { tooltipTrigger } from "../../../shared/utils/tooltipTrigger";
import { UseFields } from '../../Pi'
import { FieldData } from '../../Pi/types'
import { ShopConfig } from "../types";
import NoticeCard from './NoticeCard.vue'
import { Notice, NoticeState, PayStatus } from './types'

@Component({
  components: {
    NoticeCard,
  },
    methods: {
      tooltipTrigger,
      moment,
  }
})
export default class ShopNotices extends UseFields {
  @Prop() getNotices!: ShopConfig['getNotices']

  @Prop() removeNotice!: ShopConfig['removeNotice']

  @Prop() getPreview!: ShopConfig['getPreview']

  @Prop() refundPayment!: ShopConfig['refundPayment']

  payStatusOptions = [
    { label: this.$t('shop_notices_status_option_paid'), value: PayStatus.Paid },
    { label: this.$t('shop_notices_status_option_unpaid'), value: PayStatus.Unpaid }
  ]

  noticeStatusIcon(notice: Notice) {
      if (notice.state === NoticeState.Refunded) {
        return 'undo'
      } else {
        if (notice.payment) {
          return 'check-circle'
        } else {
          return 'close-circle'
        }
      }
  }

  noticeStatusTitle(notice: Notice) {
    if (notice.state === NoticeState.Refunded) {
      return this.$t('shop_notice_payment_refunded').toString()
    } else {
      if (notice.payment) {
        return this.$t('shop_notice_payment_success').toString()
      } else {
        return this.$t('shop_notice_payment_fail').toString()
      }
    }
  }

  noticeStatusIconClass(notice: Notice) {
    if (notice.state === NoticeState.Refunded) {
      return 'text-warning'
    } else {
      if (notice.payment) {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    }
  }

  setPayStatus(arg: FieldData): FieldData {
    arg.setter = (val) => {
      this.payStatus = val
      this.notices = []

      this.pageSizeChanger({ pageSize: this.pageSize, current: 1 })
    }
    return arg
  }

  pageSize = 10

  page = 1

  noticesCount = 0

  payStatus: null | PayStatus = PayStatus.Paid

  notices: Array<Notice> = []

  noticesOffset = 0

  isLoading = false

  removeNoticeHandler(id: number): void {
    this.removeNotice(id)
      .then(() => {
        const index = this.notices.findIndex((n) => n.id === id)

        if (index !== -1) {
          this.notices.splice(index, 1)
        }
      })
  }

  pageSizeChanger({ current, pageSize }: { current: number, pageSize: number }): void {
    let offset = 0

    if (pageSize === this.pageSize) {
      this.page = current
      offset = (current - 1) * pageSize
    } else {
      this.page = current === 1 ? 1 : Math.ceil(this.page * this.pageSize / pageSize)
      offset = this.page === 1 ? 0 : this.page * pageSize
    }
    this.pageSize = pageSize

    this.isLoading = true

    this.getNotices({
      offset,
      limit: pageSize,
      pay_status: this.payStatus ?? undefined
    })
      .then(({ count, items }) => {
        this.notices = items

        this.noticesCount = count
      })
      .finally(() => this.isLoading = false)
  }

  refund(notice: Notice) {
    if (typeof this.refundPayment === 'function') {
      this.refundPayment(notice)
        .then(res => {
          if (res) {
            const n = this.notices.find(n => n.id === notice.id)

            if (n) {
              n.state = notice.state
            }
          }
        })
    }
  }

  created(): void {
    this.isLoading = true

    this.pageSizeChanger({ current: 1, pageSize: this.pageSize })
  }
}
